<template>
  <v-card outlined class="petmed-clinic-table">
    <div class="pa-4 pb-2">
      <span class="pw-section">Atenciones y monto por clínica</span>
    </div>

    <div v-if="error" class="state-msg pa-6 text-center">
      <v-icon small color="error" class="mr-1">mdi-alert-circle-outline</v-icon>
      No se pudo cargar el detalle por clínica.
    </div>

    <v-data-table
      v-else
      :headers="headers"
      :items="rows"
      :loading="loading"
      item-key="clinicId"
      sort-by="attendances"
      sort-desc
      :items-per-page="10"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1], itemsPerPageText: 'Filas por página' }"
      no-data-text="Sin atenciones en el período seleccionado"
      loading-text="Cargando clínicas…"
      dense
    >
      <template v-slot:item.pawerCoverage="{ item }">{{ item.pawerCoverage | clp }}</template>
      <template v-slot:item.paidAmount="{ item }">{{ item.paidAmount | clp }}</template>
      <template v-slot:item.pendingAmount="{ item }">
        <span :class="{ 'pending-amount': item.pendingAmount > 0 }">{{ item.pendingAmount | clp }}</span>
      </template>
      <template v-slot:item.userPayment="{ item }">{{ item.userPayment | clp }}</template>

      <template v-slot:body.append>
        <tr v-if="rows.length > 0" class="pw-total-row">
          <td>Total</td>
          <td class="text-right pw-num">{{ totals.attendances }}</td>
          <td v-for="line in businessLines" :key="line.key" class="text-right pw-num">
            {{ totals.byBusinessLine[line.key] }}
          </td>
          <td class="text-right pw-num">{{ totals.pawerCoverage | clp }}</td>
          <td class="text-right pw-num">{{ totals.paid | clp }}</td>
          <td class="text-right pw-num">{{ totals.pending | clp }}</td>
          <td class="text-right pw-num">{{ totals.userPayment | clp }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { BUSINESS_LINES, clinicTotals, normalizeBusinessLine } from '@/utils/petmed-metrics.utils';

const HEADERS = [
  { text: 'Clínica', value: 'clinicName' },
  { text: 'Atenciones', value: 'attendances', align: 'end' },
  ...BUSINESS_LINES.map(({ key, label }) => ({ text: label, value: `bl_${key}`, align: 'end' })),
  { text: 'Cobertura comprometida', value: 'pawerCoverage', align: 'end' },
  { text: 'Pagado', value: 'paidAmount', align: 'end' },
  { text: 'Pendiente', value: 'pendingAmount', align: 'end' },
  { text: 'Pago usuarios', value: 'userPayment', align: 'end' },
];

export default {
  name: 'PetmedByClinicTable',

  props: {
    // insights.byClinic del contrato
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },

  data() {
    return { headers: HEADERS, businessLines: BUSINESS_LINES };
  },

  computed: {
    // Aplana paid/pending y las líneas de negocio (bl_<key>) para que
    // v-data-table pueda ordenar por esas columnas.
    rows() {
      return this.items.map((c) => {
        const lines = normalizeBusinessLine(c.byBusinessLine);
        return {
          clinicId: c.clinicId,
          clinicName: c.clinicName,
          attendances: c.attendances,
          pawerCoverage: c.pawerCoverage,
          paidAmount: c.paid ? c.paid.amount : 0,
          pendingAmount: c.pending ? c.pending.amount : 0,
          userPayment: c.userPayment,
          ...BUSINESS_LINES.reduce((acc, { key }) => ({ ...acc, [`bl_${key}`]: lines[key] }), {}),
        };
      });
    },
    totals() {
      return clinicTotals(this.items);
    },
  },
};
</script>

<style scoped>
.state-msg {
  font-size: 13px;
  color: var(--pw-text-muted);
}
.pending-amount {
  color: var(--pw-warning);
  font-weight: 600;
}
</style>
